module.exports = __webpack_public_path__ + "img/special.dc55179b.png";